const manufacturingWorkStepTypes = [
	{
		manufacturingWorkStepType: 10,
		displayName: "Tafel-NC-Erzeugung",
		workplaceName: "",
		workStepName: "",
	},
	{
		manufacturingWorkStepType: 20,
		displayName: "2D-Tafelbearbeitung",
		workplaceName: "",
		workStepName: "",
	},
	{
		manufacturingWorkStepType: 30,
		displayName: "Kombibearbeitung / Features",
		workplaceName: "",
		workStepName: "",
	},
	{
		manufacturingWorkStepType: 35,
		displayName: "Teilevereinzelung",
		workplaceName: "",
		workStepName: "",
	},
	{
		manufacturingWorkStepType: 40,
		displayName: "Manuell entgraten",
		workplaceName: "",
		workStepName: "",
	},
	{
		manufacturingWorkStepType: 50,
		displayName: "Webern",
		workplaceName: "",
		workStepName: "",
	},
	{
		manufacturingWorkStepType: 60,
		displayName: "Trowalisieren",
		workplaceName: "",
		workStepName: "",
	},
	{
		manufacturingWorkStepType: 65,
		displayName: "Einpressungen",
		workplaceName: "",
		workStepName: "",
	},
	{
		manufacturingWorkStepType: 70,
		displayName: "Abkanten",
		workplaceName: "",
		workStepName: "",
	},
	{
		manufacturingWorkStepType: 80,
		displayName: "Schweißen",
		workplaceName: "",
		workStepName: "",
	},
	{
		manufacturingWorkStepType: 90,
		displayName: "Pulverbeschichten",
		workplaceName: "",
		workStepName: "",
	},
	{
		manufacturingWorkStepType: 100,
		displayName: "Feuerverzinken",
		workplaceName: "",
		workStepName: "",
	},
	{
		manufacturingWorkStepType: 110,
		displayName: "Galv. verzinken",
		workplaceName: "",
		workStepName: "",
	},
];

export default manufacturingWorkStepTypes;
